import useTimer from "../hooks/useTimer";
import "../css/Dashboard.css";

const ArrivedTimer = ({ arrivedAt, statusId }) => {
    const { hours, minutes, seconds } = useTimer(arrivedAt, statusId);

    if (!arrivedAt) return null;

    return (
        <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '3px 8px', borderRadius: 6, width: 'fit-content',
            background: '#fefce8', border: '1px solid #fde68a',
            fontSize: 12, color: '#92400e', fontWeight: 600, marginTop: 4,
        }}>
            <span style={{
                width: 6, height: 6, borderRadius: '50%',
                background: '#f59e0b', flexShrink: 0,
            }}/>
            Waiting at rest. &nbsp;
            <span style={{ fontVariantNumeric: 'tabular-nums' }}>
                {hours > 0 && `${hours}h `}{minutes}m {seconds}s
            </span>
        </div>
    );
};

export default ArrivedTimer;